exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gantt-elastic__chart-row-progress-bar-outline:hover {\n  cursor: w-resize;\n}\n.gantt-elastic__chart-row-bar:hover .gantt-elastic__chart-row-progress-bar-outline {\n  stroke-width: calc(var(--stroke-width) * 2) !important;\n}\n", ""]);

// exports
